'use strict';

var aspectRatioPercentage = function aspectRatioPercentage() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1:1';
  var ratioArr = ratio.split(':');
  var width = parseFloat(ratioArr[0]);
  var height = parseFloat(ratioArr[1]);

  // Calculate percentage value using 'width' and 'height'
  return height / width * 100;
};

module.exports = aspectRatioPercentage;
